'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Controllable = require('../decorators/Controllable');

var _Controllable2 = _interopRequireDefault(_Controllable);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactUtils = require('react-utils');

var _devLogger = require('react-utils/devLogger');

var _devLogger2 = _interopRequireDefault(_devLogger);

var _icons = require('icons/icons');

var _icons2 = _interopRequireDefault(_icons);

var _SyntheticEvent = require('../core/SyntheticEvent');

var _SyntheticEvent2 = _interopRequireDefault(_SyntheticEvent);

var _UICaret = require('../icon/icons/UICaret');

var _UICaret2 = _interopRequireDefault(_UICaret);

var _UIIcon = require('../icon/UIIcon');

var _UIIcon2 = _interopRequireDefault(_UIIcon);

var _UIClickable = require('../button/UIClickable');

var _UIClickable2 = _interopRequireDefault(_UIClickable);

var _tshirtSize = require('../utils/propTypes/tshirtSize');

var TShirtSize = _interopRequireWildcard(_tshirtSize);

var _CSSHeightTransition = require('../animation/CSSHeightTransition');

var _CSSHeightTransition2 = _interopRequireDefault(_CSSHeightTransition);

var _times = require('HubStyleTokens/times');

var _IconConstants = require('../icon/IconConstants');

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var TRANSITION_ANIMATION_TIMEOUT = parseInt(_times.ACCORDION_TRANSITION_ANIMATION_TIMING, 10);

var UIAccordionItem = _react2.default.createClass({
  displayName: 'UIAccordionItem',

  propTypes: {
    children: _react.PropTypes.node,
    className: _react.PropTypes.string,
    contentClassName: _react.PropTypes.string,
    disabled: _react.PropTypes.bool.isRequired,
    onOpenChange: _react.PropTypes.func,
    open: _react.PropTypes.bool,
    textElement: _react.PropTypes.string,
    title: _react.PropTypes.node.isRequired,
    size: TShirtSize.allSizes
  },

  getDefaultProps: function getDefaultProps() {
    return {
      disabled: false,
      open: false,
      size: 'extra-small',
      textElement: 'span'
    };
  },
  getInitialState: function getInitialState() {
    var open = this.props.open;

    return {
      openComplete: open
    };
  },
  componentDidUpdate: function componentDidUpdate(prevProps) {
    var _this = this;

    var open = this.props.open;

    if (prevProps.open !== open) {
      clearTimeout(this._openCompleteTimeout);
      this._openCompleteTimeout = setTimeout(function () {
        _this.setState({ openComplete: open });
      }, TRANSITION_ANIMATION_TIMEOUT);
    }
  },
  getClassName: function getClassName(open, size, textElement) {
    return (0, _reactUtils.classNames)('private-accordion', 'private-accordion--' + TShirtSize.fromProp(size).short, {
      'private-accordion--open': open,
      'private-accordion--legacy': textElement !== 'span'
    });
  },
  handleTitleClick: function handleTitleClick() {
    var _props = this.props,
        onOpenChange = _props.onOpenChange,
        open = _props.open;

    onOpenChange((0, _SyntheticEvent2.default)(!open));
  },
  renderContent: function renderContent(children, open, contentClassName) {
    if (children == null) {
      return null;
    }

    return _react2.default.createElement(
      _CSSHeightTransition2.default,
      {
        className: 'private-accordion__height-transition private-accordion__content-wrapper',
        open: open,
        animationTiming: TRANSITION_ANIMATION_TIMEOUT
      },
      _react2.default.createElement(
        'div',
        {
          className: (0, _reactUtils.classNames)('UIAccordionItem-content', 'private-accordion__content', contentClassName)
        },
        children
      )
    );
  },
  renderIcon: function renderIcon(textElement) {
    if (textElement !== 'span') {
      _devLogger2.default.warn({
        message: 'UIAccordionItem: the `textElement` prop is no longer recommended ' + 'and may be removed in the future. Please use the `size` prop instead.',
        key: 'UIAccordionItem: use size prop'
      });
    }

    // To fix a bug in IE11 with extra space added to the SVG, this uses a
    // <canvas> element as a sibling to the SVG to work around it (detailed in
    // https://stackoverflow.com/a/30416241). Hack passed inline to keep this
    // more portable and keep the logic in the component vs. the stylesheet

    if (textElement === 'span') {
      return _react2.default.createElement(
        'div',
        { className: 'private-accordion__indicator' },
        _react2.default.createElement('canvas', {
          width: _IconConstants.CARET_WIDTH,
          height: _IconConstants.CARET_HEIGHT,
          style: { display: 'block', width: '100%', visibility: 'hidden' }
        }),
        _react2.default.createElement(_UICaret2.default, {
          className: 'private-accordion__indicator__inner',
          style: { position: 'absolute', width: '100%', left: 0, top: 0 },
          viewBoxHeight: _IconConstants.CARET_HEIGHT,
          viewBoxWidth: _IconConstants.CARET_WIDTH,
          width: 12
        })
      );
    }

    return _react2.default.createElement(_UIIcon2.default, { className: 'private-accordion__indicator', name: _icons2.default.RIGHT });
  },
  render: function render() {
    var _props2 = this.props,
        children = _props2.children,
        contentClassName = _props2.contentClassName,
        disabled = _props2.disabled,
        __onOpenChange = _props2.onOpenChange,
        open = _props2.open,
        size = _props2.size,
        textElement = _props2.textElement,
        title = _props2.title,
        rest = _objectWithoutProperties(_props2, ['children', 'contentClassName', 'disabled', 'onOpenChange', 'open', 'size', 'textElement', 'title']);

    var TextElement = textElement; // 'span' by default

    return _react2.default.createElement(
      'div',
      rest,
      _react2.default.createElement(
        _UIClickable2.default,
        {
          'aria-expanded': open ? 'true' : 'false',
          className: this.getClassName(open, size, textElement),
          'data-open-complete': this.state.openComplete,
          disabled: disabled,
          onClick: this.handleTitleClick
        },
        _react2.default.createElement(
          TextElement,
          { className: 'private-accordion__text-wrapper' },
          this.renderIcon(textElement),
          title
        )
      ),
      this.renderContent(children, open, contentClassName)
    );
  }
});

exports.default = (0, _Controllable2.default)(UIAccordionItem, ['open']);
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/UIComponents/static-2.1282/js/accordion/UIAccordionItem.js
// module id = 364
// module chunks = 0